import React from 'react'
import { useParams, Link } from "react-router-dom"
import { useFetchData } from '../../../../Hooks/Main/useFetchData'
import Spinner from "react-bootstrap/esm/Spinner";
import LazyImage from '../../../../Components/LazyImage';
import HtmlDecode from '../../../../Utils/HtmlDecode';

const imgPath = process.env.REACT_APP_FILE_URL

function ServiceSliderDetails() {
    const { id } = useParams()
    const { data, isLoading } = useFetchData(`viewServiceDetails/${id}`)
    
  return !isLoading ? (
      
    <div className="container-fluid  p-0">
        <div className="position-relative d-flex justify-content-center pagesHeaderCoverImages">
            <LazyImage
            src={`${imgPath}${data?.images?.file}`}
            fluid
            alt="child labour image mt-5"
            bsPrefix="img"/> 
        <div className="image-frame__wrapper">
          <h2>{data?.localContent[0]?.title}</h2>
        </div>
      </div>
        <div className="container">
              <div className="row mt-4">
                  <div className='col-md-9 mb-3'>
                      {data?.localContent?.map((content, index) => {
                          return (
                            <div className='container-fluid my-3' key={index}>
                                {index!==0 && <h6>{content.title}</h6>}
                                  <p>
                                      <span
                                    key={index}
                                    dangerouslySetInnerHTML={{
                                    __html: HtmlDecode(content?.content),
                                    }}
                                      />
                                  </p>
                            </div>
                        )
                    })}
                  </div>
              </div>
              <div className="row px-3 text-center">
                <div>
                    <Link
                  to={`../donation/${data?._id}`}
                  className="btn btn-block web-btn-outlined"
                >
                  Want to Donate
                </Link>
                </div>
              </div>
          </div>
      </div>
      
  ):<div className="d-flex justify-content-center mt-3">
      <Spinner animation="grow" className="me-2" />
      Loading Content...
    </div>
}

export default ServiceSliderDetails